(function(){
  var focusTimer;

  PegasusTemplate.RowSidePanelView =Em.ContainerView.extend({
    tagName: 'div',

    viewName: 'rowPositioner',

    focusOnRow: function(){
      // hide the picker if we look at a different row
      Em.run.cancel( focusTimer );
      Em.run.scheduleOnce('afterRender', this, 'positionMe');
    }.observes('controller.content'),

    timer: null,
    lastPositionLeft: null,
    lastPositionTop: null,

    positionMe: function(){
      var $row;
      var zoom = this.get('controller.zoomValue');

      $this = this.$();

      if ( !$this ) { return; }

      if ( !this.get('controller.content') ) {
        if ( $this ) {
          $('.vr-frame-line').hide();
          $this.hide();
        }
        return;
      }

      $row = this.get('controller.content').$();
      rowPosition = $row.position();

      if ( !$row ) { return; }

      var isLast = $row.attr('id') === $('.vr-row:last').attr('id');
      var isFirst = $row.attr('id') === $('.vr-row:first').attr('id');


      $this.css({
        position: 'absolute',
        display: 'block',
        height: $row.outerHeight() - 4,
        top: rowPosition.top,
        left: rowPosition.left - $this.width() - 2
      });

      var borderWidth = 2;

      var offset = 6;
      var rootTop    = rowPosition.top  - offset;
      var rootLeft   = rowPosition.left - offset;
      var height     = $row.height()        + ( offset * 2 ) - borderWidth;
      var rootBottom = rootTop + height;

      var topBottomBarWidth = $row.width() + ( offset * 2 );
      var border = 'dashed ' + borderWidth + 'px gray';

      var radius = parseInt( $('.email-style-wrapper').css('borderRadius'), 10);
      var topWidth = topBottomBarWidth - 10;
      var topLeft = rootLeft + 5;
      var leftTop = rootTop + 5;
      var leftHeight = height - 10;
      var rightHeight = leftHeight;
      var rightTop = leftTop;
      var bottomWidth = topWidth;
      var bottomLeft = topLeft;

      if ( isFirst ) {
        topWidth = topWidth - ( radius * 2 );
        topLeft = rootLeft + radius + 5;
        leftTop = leftTop + radius;
        leftHeight = height - radius - 10;
        rightTop = leftTop;
        rightHeight = leftHeight;
      } else if( isLast) {
        bottomWidth = bottomWidth - ( radius * 2 );
        bottomLeft = bottomLeft + radius;
        leftHeight = leftHeight - radius;
        rightTop = leftTop;
        rightHeight = leftHeight;
      }
    },

    didInsertElement: function(){
      this._super();
      this.focusOnRow();
    },

    willDestroyElement: function(){
      //$(window).off('frameChanged');
      this._super();
    },

    spectrumIcon: Em.View.extend({
      tagName: 'div',
      classNames: ['row-spectrum-button'],
      template: Em.Handlebars.compile('<span class="button-label">{{t g.row}}</span>'),
      click: function(){
        var index = PegasusTemplate.blockRegionInstance.indexOf( this.get('controller.content') );
        var instruction = function(){
          Em.run.scheduleOnce('afterRender', this.get('controller'), function(){
            this.set('content', PegasusTemplate.blockRegionInstance.objectAt( index ) );
            PegasusTemplate.stateMachine.transitionTo('editing.backgroundImage', this.get('backgroundImageCell') );
          });
        };

        PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', instruction.bind(this));
        PegasusTemplate.stateMachine.send('didFinishEditing');

        return false;
      },
      propertyName: 'data-row-color'
    }),

    rotateIndicator: Em.View.extend({
      tagName: 'li',
      classNames: ['row-rotate-indicator'],
      template: Em.Handlebars.compile(''),
      click: function(){
        this.get('controller').rotateRow();
      }
    }),

    copyIndicator: Em.View.extend({
      tagName: 'div',
      classNames: ['row-copy-arrow'],
      template: Em.Handlebars.compile('<span class="button-label">{{t g.copy}}</span>'),
      click: function(){
        var row = this.get('controller.content');
        var klass = row.constructor;
        var cookie = row.mutateForOut(null,true).editor_cookie;
        var index = PegasusTemplate.blockRegionInstance.indexOf( row ) + 1;

        var instruction = function(){
          this.get('parentView').$().hide();
          this.get('controller').copyRow(klass, cookie, index);
        };

        PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', instruction.bind(this));
        PegasusTemplate.stateMachine.send('didFinishEditing');
      }
    }),
    deleteIndicator: Em.View.extend({
      tagName: 'div',
      classNames: ['row-delete-arrow'],
      template: Em.Handlebars.compile('<span class="button-label">{{t g.delete}}</span>'),
      click: function(){
        var row = this.get('controller.content');
        var klass = row.constructor;
        var cookie = row.mutateForOut(null,true).editor_cookie;
        var source = row.get('sourceElement');
        var index = PegasusTemplate.blockRegionInstance.indexOf( row );

        var instruction = function(){
          this.get('parentView').$().hide();
          this.get('controller').deleteRow(klass, cookie, source, index);
        };

        PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', instruction.bind(this));
        PegasusTemplate.stateMachine.send('didFinishEditing');
      }
    }),
    upArrow: Em.View.extend({
      tagName: 'div',
      classNames: ['row-up-arrow'],
      template: Em.Handlebars.compile(''),
      moveTo: 1,
      //mouseEnter: function(e){
        //if ( e.buttons === 1 ) {
          //this.mouseDown(e);
        //}
      //},
      mouseLeave: function(e){
        $('.vr-row-position-selector').remove();
      },

      mouseUp: function(){
        var currentIndex = PegasusTemplate.blockRegionInstance.indexOf( this.get('controller.content') );
        var instruction = function(){
          $('.vr-row-position-selector').remove();
          this.get('parentView').$().hide();
          this.get('controller').moveRowUp(1, currentIndex);
        };

        PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', instruction.bind(this));
        PegasusTemplate.stateMachine.send('didFinishEditing');
      }
    }),
    downArrow: Em.View.extend({
      tagName: 'div',
      classNames: ['row-down-arrow'],
      template: Em.Handlebars.compile(''),
      moveTo: 1,
      //mouseEnter: function(e){
        //if ( e.buttons === 1 ) {
          //this.mouseDown(e);
        //}
      //},
      mouseLeave: function(e){
        $('.vr-row-position-selector').remove();
      },
      mouseUp: function(){
        var currentIndex = PegasusTemplate.blockRegionInstance.indexOf( this.get('controller.content') );
        var instruction = function(){
          $('.vr-row-position-selector').remove();
          this.get('parentView').$().hide();
          this.get('controller').moveRowDown(1, currentIndex);
        };

        PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', instruction.bind(this));
        PegasusTemplate.stateMachine.send('didFinishEditing');
      }
    }),
    mirrorView: Em.View.extend({
      tagName: 'div',
      classNames: ['row-mirror-arrow'],
      isVisible: function(){
        return this.get('controller.mirrorCapable') && ( this.get('controller.mirrorCapable').length > 1 );
      }.property('controller.content'),
      template: Em.Handlebars.compile('<span draggable="false" class="vr-swap button-label">{{t g.column}}</span><span class="vr-shift button-label">{{t g.select}}</span>'),
      click: function(){
        var index = PegasusTemplate.blockRegionInstance.indexOf( this.get('controller.content') );
        var instruction = function(){
          Em.run.next(this, function(){
            var target = PegasusTemplate.blockRegionInstance.objectAt(index);
            Em.run.scheduleOnce('afterRender', this, function(){
              target.$().imagesLoaded().always(function(){
                Em.run.scheduleOnce('afterRender', this, function(){
                  this.set('controller.content', target);
                  var column = target.get('mirrorCapable.firstObject');
                  PegasusTemplate.stateMachine.send('mirrorRow');
                  this.set('controller.controllers.columnOperations.content', column);
                });
              }.bind(this));
            });
          });
        };

        PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', instruction.bind(this));
        PegasusTemplate.stateMachine.send('didFinishEditing');
        return false;
      }
    }),
    lockButton: Em.View.extend({
      tagName: 'li',
      classNames: ['row-lock-button'],
      classNameBindings: ['locked'],
      template: Em.Handlebars.compile(''),
      locked: Em.computed.equal( 'controller.dataRowLocked', 'true'),
      click: function(){
        this.get('controller').toggleLock();
      }
    }),
    emptyIndicator: Em.View.extend({
      tagName: 'li',
      classNames: ['row-empty-indicator'],
      classNameBindings: ['locked'],
      template: Em.Handlebars.compile('')
    })
  });

  PegasusTemplate.RowOperationsView = Em.View.extend({
    templateName: 'row_operations',
    attributeBindings: ['draggable'],
    draggable: 'false',
    structuralOperations: PegasusTemplate.RowSidePanelView.extend({
      childViews: ['deleteIndicator', 'spectrumIcon', 'copyIndicator'],
      classNames: ['row-structure-operations'],

      didInsertElement: function(){
        this._super();
      },

      lastPositionTop: null,
      lastPositionLeft: null,
      timer: null,

      positionMe: function(){
        var $row,
          rowPosition,
          $this = this.$(),
          zoom = this.get('controller.zoomValue');

        if ( !this.get('controller.content') ) {
          if ( $this ) {
            $this.hide();
          }
          return;
        }

        // we fire this enough that it has the potential to race
        try {
          $row = this.get('controller.content').$();
          rowPosition = $row.position();

          var isLast = $row.attr('id') === $('.vr-row:last').attr('id');
          var isFirst = $row.attr('id') === $('.vr-row:first').attr('id');

          var rowHeight = $row.height();
          var offsetTop = rowHeight >= 110 ? 0 : (rowHeight - 110) / 2;

          if ( isFirst ) {
            offsetTop = 0;
          }

          var offsetParentWidth = $row.offsetParent().width();
          var maxWidth = PegasusTemplate.loadedTemplate().get('maxContentWidth');

          var right = (((100*offsetParentWidth) / (zoom*100)) * 100) > (maxWidth + 140) ? (offsetParentWidth - maxWidth) / 2 : 75;
          var top = Math.floor(rowPosition.top + offsetTop);

          var actualRight = ((100*right) / (zoom*100)) * 100;
          var actualTop = ((100*top) / (zoom*100)) * 100;

          var rowHeight = $row.outerHeight();

          this.$().css({
            position: 'absolute',
            display: 'block',
            height: rowHeight,
            top: actualTop,
            right: right
            //right: $row.position().left - (2*parseInt(this.get('controller.controllers.toolbar.selectedBorderWidth'), 10)) - 2
          });
        } catch(e) {
          //Em.run.scheduleOnce('afterRender', this, 'positionMe');
        }
      }
    }),
    alterations: PegasusTemplate.RowSidePanelView.extend({
      tagName: 'div',
      childViews: ['upArrow', 'mirrorView', 'downArrow'],
      classNames: ['row-arrows'],
      attributeBindings: ['draggable'],
      draggable: 'false',

      lastPositionTop: null,
      lastPositionLeft: null,
      timer: null,

      positionMe: function(){
        var $row,
          rowPosition,
          $this = this.$(),
          zoom = this.get('controller.zoomValue');

        // we fire this enough that it has the potential to race
        try {
          if ( !this.get('controller.content') ) {
            if ( $this ) {
              $this.hide();
            }
            return;
          }


          $row = this.get('controller.content').$();
          rowPosition = $row.position();

          var isLast = $row.attr('id') === $('.vr-row:last').attr('id');
          var isFirst = $row.attr('id') === $('.vr-row:first').attr('id');

          if ( isLast ) {
            $this.addClass('vr-last-row');
          } else {
            $this.removeClass('vr-last-row');
          }
          if ( isFirst ) {
            $this.addClass('vr-first-row');
          } else {
            $this.removeClass('vr-first-row');
          }

          var rowHeight = $row.height();
          var offsetTop = rowHeight >= 110 ? 0 : (rowHeight - 110) / 2;

          if ( isFirst ) {
            offsetTop = 0;
          }

          var offsetParentWidth = $row.offsetParent().width();
          var maxWidth = PegasusTemplate.loadedTemplate().get('maxContentWidth');
          var left = (((100*offsetParentWidth) / (zoom*100)) * 100) > (maxWidth + 140) ? (offsetParentWidth - maxWidth) / 2 : 70;
          var top = Math.floor(rowPosition.top + offsetTop);

          var actualLeft = ((100*left) / (zoom*100)) * 100;
          var actualTop = ((100*top) / (zoom*100)) * 100;

          this.$().css({
            position: 'absolute',
            display: 'block',
            height: $row.outerHeight(),
            top: actualTop,
            left: left
          });
        } catch(e) {
          //Em.run.next(this, 'positionMe');
        }
      }
    })
  });
})();
